const txtInvalido = 'Campo obligatorio';
export const messageErrorCustomer = {
  identityDocument: [
    { type: 'required', message: txtInvalido },
    { type: 'pattern', message: 'Solo números y letras' }
  ],
  name: [
    { type: 'required', message: txtInvalido },
    { type: 'pattern', message: 'Solo letras' }
  ],
  lastName: [
    { type: 'required', message: txtInvalido },
    { type: 'pattern', message: 'Solo letras' }
  ],
  email: [
    { type: 'required', message: txtInvalido },
    { type: 'email', message: 'Formato inválido' }
  ],
  phone: [
    { type: 'required', message: txtInvalido },
    { type: 'minlength', message: 'Mínimo $ números' },
    { type: 'maxlength', message: 'Máximo $ números' },
    { type: 'pattern', message: 'Solo números' }
  ],
  numDocReceiver: [{ type: 'required', message: txtInvalido }],
  nameReceiver: [
    { type: 'required', message: txtInvalido },
    { type: 'pattern', message: 'Solo letras' }
  ]
};
export const messageErrorDirection = {
  address: [{ type: 'required', message: txtInvalido }],
  block: [{ type: 'required', message: txtInvalido }],
  floor: [
    { type: 'required', message: txtInvalido },
    { type: 'max', message: 'Valor máximo 50' },
    { type: 'min', message: 'Valor mínimmo 1' }
  ],
  via: [{ type: 'required', message: txtInvalido }],
  number: [{ type: 'required', message: txtInvalido }],
  district: [{ type: 'required', message: txtInvalido }],
  department: [{ type: 'required', message: txtInvalido }],
  province: [{ type: 'required', message: txtInvalido }],
  ubigeoCode: [{ type: 'required', message: 'Seleccione un distrito' }]
};
export const messageErrorLogin = {
  user: [
    { type: 'required', message: txtInvalido },
    { type: 'pattern', message: 'Caracter inválido' },
    { type: 'maxlength', message: 'Máximo 20 dígitos' }
  ],
  password: [
    { type: 'required', message: txtInvalido },
    { type: 'minlength', message: '' },
    { type: 'maxlength', message: 'Máximo 20 dígitos' }
  ],

  passwordNew: [{ type: 'required', message: txtInvalido }],
  passwordNewTwo: [{ type: 'required', message: txtInvalido }]
};
export const messageErrorUpdatePassword = {
  numDocument: [
    { type: 'required', message: txtInvalido },
    { type: 'pattern', message: 'Solo números' },
    { type: 'minlength', message: 'Mínimo 8 números' },
    { type: 'maxlength', message: 'Máximo 9 números' }
  ],
  lastName: [{ type: 'required', message: txtInvalido }],
  user: [{ type: 'required', message: txtInvalido }],
  passwordNewTwo: [{ type: 'required', message: txtInvalido }]
};

export const messageErrorEntity = {
  entityCode: [{type: 'incorrect', message: 'Seleccione una entidad'}]
};
